import { find, isEmpty, map, snakeCase } from "lodash";
import { navigate } from "gatsby";
import queryString from "query-string";

import { formatParams } from "~/utilities/translations";
import { mergeDeep } from "~/utilities/helpers";

export default class Header {
    constructor(props) {
        this.props = props.translationProps;
    }

    maybeRedirect() {
        const { activeCode, urlPermutations, location } = this.props;

        if (isEmpty(urlPermutations)) {
            return;
        }

        const search = formatParams(activeCode, location.search);

        const pathname = `${location.pathname}${activeCode}/`;
        const link = find(urlPermutations, { link: pathname })?.link;

        if (link && link !== location.pathname) {
            navigate(`${link}?${search}`);
        }
    }

    maybeUpdateUrl() {
        const { activeCode, englishCode, codeName, location } = this.props;
        const queryCode = queryString.parse(location.search)[codeName];

        if (activeCode === englishCode || activeCode === queryCode) {
            return;
        }

        const search = formatParams(activeCode, location.search);

        navigate(`?${search}`);
    }

    parsePermutations() {
        const { urlPermutations, activeCode, location } = this.props;

        return map(urlPermutations, (permutation) => {
            const values = formatParams(
                permutation.languageCode,
                location.search,
            );

            return {
                ...permutation,
                link: `${permutation.link}?${values}`,
                isActive: permutation.languageCode === activeCode,
            };
        });
    }

    parseLocation() {
        const { activeLanguages, location, activeCode } = this.props;

        return map(activeLanguages, (language) => {
            const link = `${location.pathname}?${formatParams(
                language.code,
                location.search,
            )}`;

            const locale = snakeCase(language.default_locale);

            const isActive =
                activeCode === language.code || activeCode === locale;

            return {
                ...language,
                isActive,
                languageCode: language.code,
                link,
            };
        });
    }

    translate(translations) {
        let languages = this.parsePermutations();
        const { englishCode, activeCode } = this.props;

        if (isEmpty(languages)) {
            languages = this.parseLocation();
        }

        const englishNavigation =
            find(translations, {
                languageCode: englishCode,
            }) || {};

        if (activeCode === englishCode) {
            return { languages, navigation: englishNavigation };
        }

        const translatedNavigation =
            find(translations, {
                languageCode: activeCode,
            }) || {};

        return {
            languages,
            navigation: mergeDeep(englishNavigation, translatedNavigation),
        };
    }
}
